// Mock data for Industry Top Consulting website

export const translations = {
  ro: {
    nav: {
      home: 'ACASĂ',
      about: 'DESPRE NOI',
      brands: 'BRANDURI',
      contact: 'CONTACT'
    },
    home: {
      slogan: 'Building Brands. Connecting People. Empowering Growth.',
      description: 'IndustryTOP Consulting LLC-FZ este o companie multi‑brand fondată în Dubai, specializată în dezvoltarea de proiecte, branduri și soluții moderne dedicate mediului de afaceri internațional.',
      descriptionExtended: 'Suntem mai mult decât o companie de consultanță – suntem un hub de inovație și dezvoltare strategică. Cu o prezență solidă în Dubai, unul dintre cele mai dinamice centre de afaceri din lume, oferim soluții integrate pentru antreprenori, companii și proiecte cu viziune globală. Fiecare brand pe care îl dezvoltăm este construit pe fundamentul solid al expertizei, profesionalismului și angajamentului față de excelență.',
      brandsTitle: 'Brandurile Noastre',
      brandsSubtitle: 'Dezvoltăm și gestionăm un portofoliu diversificat de branduri și proiecte, fiecare cu o misiune clară și un impact măsurabil. De la platforme de networking internațional până la soluții de inteligență artificială pentru business, fiecare brand din ecosistemul IndustryTOP este construit pentru a crea valoare reală și durabilă.',
      whyDubaiTitle: 'De Ce Dubai?',
      whyDubaiText: 'Dubai reprezintă poarta către piețele globale, oferind un ecosistem de afaceri dinamic, infrastructură de clasă mondială și oportunități nelimitate de creștere. Aici, viziunea devine realitate prin inovație și colaborare internațională.',
      whyDubaiExtended: 'Dubai nu este doar o locație geografică – este un ecosistem complet pentru antreprenori și companii cu ambiții globale. Cu o economie diversificată, facilități fiscale atractive, infrastructură de ultimă generație și acces direct la piețele din Orientul Mijlociu, Asia și Africa, Dubai oferă cadrul perfect pentru dezvoltarea și scalarea afacerilor moderne. Emiratele Arabe Unite sunt recunoscute la nivel mondial pentru stabilitatea politică, siguranța investițiilor și sprijinul constant pentru inovație și tehnologie.',
      advantagesTitle: 'Avantajele de a lucra cu IndustryTOP',
      advantages: [
        {
          title: 'Expertise Diversificată',
          text: 'Echipa noastră reunește experți în consultanță, strategie digitală, dezvoltare de afaceri și tehnologie. Fiecare proiect beneficiază de o abordare multidisciplinară și de cunoștințe aprofundate în multiple domenii.'
        },
        {
          title: 'Rețea Internațională',
          text: 'Prezența noastră în Dubai ne oferă acces la o rețea globală de parteneri, investitori și colaboratori. Conectăm oamenii și oportunitățile dincolo de granițe, facilitând creșterea și expansiunea internațională.'
        },
        {
          title: 'Abordare Strategică',
          text: 'Nu oferim soluții universale. Fiecare proiect este analizat individual, iar strategia este construită pe baza nevoilor specifice, resurselor disponibile și obiectivelor pe termen lung. Succesul clientului este succesul nostru.'
        }
      ],
      ctaTitle: 'Construim Împreună Viitorul',
      ctaText: 'Contactați-ne pentru colaborări și proiecte strategice. Fie că aveți o idee inovatoare, un business care necesită scalare sau doriți să vă extindeți pe piețele internaționale, echipa Industry Top este pregătită să vă susțină în fiecare etapă a călătoriei.',
      ctaButton: 'Contactează-ne'
    },
    about: {
      title: 'Despre Noi',
      description: 'IndustryTOP Consulting LLC-FZ este o companie multi‑brand înregistrată în Dubai, creată pentru a dezvolta, gestiona și scala proiecte moderne dedicate mediului de afaceri. Funcționăm ca o structură tip holding, oferind suport operațional, strategie, consultanță și infrastructură pentru proiectele și brandurile dezvoltate sub umbrela IndustryTOP.',
      descriptionExtended: 'Înființată în inima centrului financiar global din Dubai, IndustryTOP reprezintă viziunea comună a doi antreprenori pasionați de inovație, dezvoltare și impact pozitiv. Compania noastră a fost concepută pentru a răspunde nevoilor complexe ale mediului de afaceri contemporan, oferind nu doar consultanță, ci un ecosistem complet de suport pentru proiecte cu potențial de creștere exponențială. De la conceptualizare până la implementare și scalare, IndustryTOP este partenerul strategic care transformă idei în afaceri sustenabile și profitabile.',
      approachTitle: 'Abordarea Noastră',
      approachText: 'Credem în puterea colaborării și în valoarea expertizei specializate. Fiecare proiect din portofoliul nostru beneficiază de acces la resurse strategice, know-how operațional și o rețea extinsă de parteneri internaționali. Nu ne limităm la a oferi sfaturi – construim, alături de clienții și partenerii noștri, fundația pentru succesul pe termen lung. Metodologia noastră combină analiza riguroasă, creativitatea strategică și execuția impecabilă.',
      valuesTitle: 'Valorile Noastre',
      valuesIntro: 'Valorile noastre fundamentale ghidează fiecare decizie și acțiune:',
      values: ['Integritate', 'Transparență', 'Profesionalism', 'Eficiență', 'Inovație', 'Orientare spre Rezultate'],
      valuesExtended: [
        {
          value: 'Integritate',
          description: 'Acționăm cu onestitate și etică în toate interacțiunile noastre, construind relații bazate pe încredere și respect mutual.'
        },
        {
          value: 'Transparență',
          description: 'Comunicăm deschis și clar, asigurând că toți partenerii și clienții înțeleg procesele, progresele și provocările proiectelor.'
        },
        {
          value: 'Profesionalism',
          description: 'Menținem cele mai înalte standarde de calitate în tot ceea ce facem, respectând termene și depășind așteptări.'
        },
        {
          value: 'Eficiență',
          description: 'Optimizăm resurse, timp și procese pentru a livra rezultate maxime cu investiții minime.'
        },
        {
          value: 'Inovație',
          description: 'Căutăm constant noi modalități de a îmbunătăți, adapta și inova, rămânând relevanți într-o lume în continuă schimbare.'
        },
        {
          value: 'Orientare spre Rezultate',
          description: 'Succesul se măsoară în rezultate concrete, iar fiecare strategie este construită cu obiective clare și indicatori măsurabili.'
        }
      ],
      visionTitle: 'Viziune',
      vision: 'Să devenim un hub global de proiecte moderne și branduri utile pentru comunități și afaceri.',
      visionExtended: 'Aspirăm să creăm un ecosistem internațional recunoscut pentru excelență, inovație și impact pozitiv. Viziunea noastră este să fim partenerul preferat pentru antreprenori și companii care doresc să construiască branduri durabile, să acceseze piețe globale și să genereze valoare reală pentru comunitățile pe care le deservesc.',
      missionTitle: 'Misiune',
      mission: 'Crearea și creșterea brandurilor orientate spre oameni, tehnologie și progres.',
      missionExtended: 'Misiunea noastră este să identificăm oportunități, să construim soluții și să sprijinim dezvoltarea de proiecte și branduri care îmbunătățesc viața oamenilor, folosesc tehnologia în mod responsabil și contribuie la progresul global. Ne concentrăm pe sustenabilitate, scalabilitate și relevanță pe termen lung.',
      foundersTitle: 'Fondatori',
      foundersIntro: 'IndustryTOP este rezultatul viziunii împărtășite a doi antreprenori experimentați, fiecare aducând o perspectivă unică și complementară:',
      sharedVision: 'Sub umbrela IndustryTOP, cei doi fondatori urmăresc să dezvolte un ecosistem global de proiecte moderne și branduri cu impact. Împreună, Marius și Milentina combină expertiza tehnică și strategică cu abilitățile de dezvoltare comunitară și leadership, creând un mediu propice pentru inovație și creștere susținută.'
    },
    brands: {
      title: 'Brandurile Noastre',
      subtitle: 'Ecosistem de proiecte moderne cu impact global',
      viewProject: 'Vezi Proiect'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Contactați-ne pentru colaborări și parteneriate',
      introText: 'Suntem aici să vă ascultăm și să vă ajutăm să transformați ideile în realitate. Fie că doriți să aflați mai multe despre serviciile noastre, să discutați despre un proiect specific sau să explorați oportunități de colaborare, echipa Industry Top este pregătită să vă răspundă.',
      availabilityText: 'Răspundem în mod activ la toate solicitările în termen de 24-48 de ore lucrătoare. Pentru întrebări urgente sau discuții directe, vă rugăm să ne contactați prin email și vom programa o întâlnire la cel mai scurt timp.',
      form: {
        name: 'Nume',
        email: 'Email',
        message: 'Mesaj',
        send: 'Trimite Mesaj'
      },
      info: {
        company: 'IndustryTOP Consulting LLC-FZ',
        location: 'Dubai, United Arab Emirates',
        email: 'contact@industry-top.com'
      },
      success: 'Mesaj trimis cu succes!',
      error: 'A apărut o eroare. Vă rugăm încercați din nou.'
    },
    footer: {
      copyright: '© 2025 IndustryTOP Consulting LLC-FZ, Dubai, UAE. Toate drepturile rezervate.',
      built: 'Built by digital.marexon.com',
      privacyPolicy: 'Politica de Confidențialitate',
      termsOfService: 'Termeni și Condiții'
    },
    privacy: {
      title: 'Politica de Confidențialitate',
      lastUpdated: 'Ultima actualizare: 6 decembrie 2025',
      sections: [
        {
          title: '1. Introducere',
          content: 'IndustryTOP Consulting LLC-FZ ("noi", "compania noastră") este înregistrată în Dubai, Emiratele Arabe Unite. Această Politică de Confidențialitate descrie modul în care colectăm, utilizăm și protejăm informațiile dumneavoastră personale în conformitate cu legile aplicabile din UAE, inclusiv UAE Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data.'
        },
        {
          title: '2. Informații Colectate',
          content: 'Colectăm următoarele tipuri de informații: date de contact (nume, email, telefon), informații despre companie, date de utilizare a site-ului, și cookies pentru îmbunătățirea experienței utilizatorului.'
        },
        {
          title: '3. Utilizarea Informațiilor',
          content: 'Utilizăm informațiile colectate pentru: furnizarea serviciilor noastre, comunicare cu clienții, îmbunătățirea serviciilor, respectarea obligațiilor legale, și marketing (doar cu consimțământul dumneavoastră).'
        },
        {
          title: '4. Protecția Datelor',
          content: 'Implementăm măsuri de securitate tehnice și organizaționale pentru protejarea datelor personale împotriva accesului neautorizat, pierderii sau alterării. Datele sunt stocate pe servere securizate și criptate.'
        },
        {
          title: '5. Partajarea Informațiilor',
          content: 'Nu vindem și nu închiriem datele personale către terțe părți. Informațiile pot fi partajate doar cu: furnizori de servicii de încredere, autoritățile competente (la cerere legală), și parteneri de afaceri (doar cu consimțământul dumneavoastră).'
        },
        {
          title: '6. Drepturile Dumneavoastră',
          content: 'Conform legilor din UAE, aveți dreptul de: acces la datele personale, rectificare și ștergere, restricționare a prelucrării, portabilitate a datelor, și retragere a consimțământului. Pentru exercitarea acestor drepturi, contactați-ne la contact@industry-top.com.'
        },
        {
          title: '7. Cookies',
          content: 'Utilizăm cookies pentru îmbunătățirea funcționalității site-ului. Puteți gestiona preferințele de cookies prin setările browserului dumneavoastră.'
        },
        {
          title: '8. Contact',
          content: 'Pentru întrebări despre această politică, contactați-ne: IndustryTOP Consulting LLC-FZ, Dubai, UAE, Email: contact@industry-top.com'
        }
      ]
    },
    terms: {
      title: 'Termeni și Condiții',
      lastUpdated: 'Ultima actualizare: 6 decembrie 2025',
      sections: [
        {
          title: '1. Acceptarea Termenilor',
          content: 'Prin accesarea și utilizarea acestui site web, acceptați să fiți legat de acești Termeni și Condiții în conformitate cu legile din UAE, inclusiv UAE Commercial Companies Law (Federal Law No. 2 of 2015).'
        },
        {
          title: '2. Despre Companie',
          content: 'IndustryTOP Consulting LLC-FZ este o companie de consultanță înregistrată în Dubai, UAE, specializată în dezvoltarea de proiecte, branduri și soluții moderne pentru mediul de afaceri internațional.'
        },
        {
          title: '3. Utilizarea Site-ului',
          content: 'Vă acordăm o licență limitată, non-exclusivă, netransferabilă de utilizare a acestui site în scopuri legale. Este interzis: utilizarea în scopuri ilegale, încercări de accesare neautorizată, distribuirea de malware, sau copierea conținutului fără autorizație.'
        },
        {
          title: '4. Proprietate Intelectuală',
          content: 'Tot conținutul acestui site, inclusiv texte, grafice, logo-uri, imagini, și software, este proprietatea IndustryTOP Consulting LLC-FZ și este protejat de legile UAE privind drepturile de autor și proprietatea intelectuală.'
        },
        {
          title: '5. Servicii și Prețuri',
          content: 'Informațiile despre serviciile și prețurile prezentate pe acest site sunt orientative. Ofertele finale vor fi comunicate în funcție de cerințele specifice ale fiecărui client. Ne rezervăm dreptul de a modifica serviciile și prețurile fără notificare prealabilă.'
        },
        {
          title: '6. Limitarea Răspunderii',
          content: 'În măsura permisă de legea din UAE, IndustryTOP Consulting LLC-FZ nu va fi responsabilă pentru daune directe, indirecte, incidentale sau consecvente rezultate din utilizarea sau imposibilitatea de utilizare a site-ului.'
        },
        {
          title: '7. Link-uri către Terțe Părți',
          content: 'Site-ul poate conține link-uri către site-uri externe. Nu suntem responsabili pentru conținutul sau practicile de confidențialitate ale acestor site-uri.'
        },
        {
          title: '8. Modificări ale Termenilor',
          content: 'Ne rezervăm dreptul de a modifica acești termeni în orice moment. Modificările vor intra în vigoare imediat după publicarea pe site. Continuarea utilizării site-ului după modificări constituie acceptarea noilor termeni.'
        },
        {
          title: '9. Legea Aplicabilă',
          content: 'Acești termeni sunt guvernați de legile din Emiratele Arabe Unite. Orice dispută va fi rezolvată în jurisdicția instanțelor din Dubai, UAE.'
        },
        {
          title: '10. Contact',
          content: 'Pentru întrebări despre acești termeni, contactați-ne: IndustryTOP Consulting LLC-FZ, Dubai, UAE, Email: contact@industry-top.com'
        }
      ]
    }
  },
  en: {
    nav: {
      home: 'HOME',
      about: 'ABOUT US',
      brands: 'BRANDS',
      contact: 'CONTACT'
    },
    home: {
      slogan: 'Building Brands. Connecting People. Empowering Growth.',
      description: 'IndustryTOP Consulting LLC-FZ is a multi-brand company founded in Dubai, specializing in the development of modern projects, brands, and solutions dedicated to the international business environment.',
      descriptionExtended: 'We are more than a consulting company – we are a hub of innovation and strategic development. With a solid presence in Dubai, one of the world\'s most dynamic business centers, we offer integrated solutions for entrepreneurs, companies, and globally-minded projects. Every brand we develop is built on the solid foundation of expertise, professionalism, and commitment to excellence.',
      brandsTitle: 'Our Brands',
      brandsSubtitle: 'We develop and manage a diversified portfolio of brands and projects, each with a clear mission and measurable impact. From international networking platforms to artificial intelligence solutions for businesses, every brand in the IndustryTOP ecosystem is built to create real and lasting value.',
      whyDubaiTitle: 'Why Dubai?',
      whyDubaiText: 'Dubai represents the gateway to global markets, offering a dynamic business ecosystem, world-class infrastructure, and unlimited growth opportunities. Here, vision becomes reality through innovation and international collaboration.',
      whyDubaiExtended: 'Dubai is not just a geographic location – it\'s a complete ecosystem for entrepreneurs and companies with global ambitions. With a diversified economy, attractive tax facilities, state-of-the-art infrastructure, and direct access to markets in the Middle East, Asia, and Africa, Dubai offers the perfect framework for developing and scaling modern businesses. The United Arab Emirates are globally recognized for political stability, investment security, and constant support for innovation and technology.',
      advantagesTitle: 'Advantages of Working with IndustryTOP',
      advantages: [
        {
          title: 'Diversified Expertise',
          text: 'Our team brings together experts in consulting, digital strategy, business development, and technology. Each project benefits from a multidisciplinary approach and deep knowledge across multiple domains.'
        },
        {
          title: 'International Network',
          text: 'Our presence in Dubai gives us access to a global network of partners, investors, and collaborators. We connect people and opportunities across borders, facilitating growth and international expansion.'
        },
        {
          title: 'Strategic Approach',
          text: 'We don\'t offer one-size-fits-all solutions. Each project is analyzed individually, and the strategy is built based on specific needs, available resources, and long-term objectives. Our client\'s success is our success.'
        }
      ],
      ctaTitle: 'Building the Future Together',
      ctaText: 'Contact us for collaborations and strategic projects. Whether you have an innovative idea, a business that needs scaling, or you want to expand into international markets, the Industry Top team is ready to support you at every stage of your journey.',
      ctaButton: 'Contact Us'
    },
    about: {
      title: 'About Us',
      description: 'IndustryTOP Consulting LLC-FZ is a multi-brand company registered in Dubai, created to develop, manage, and scale modern projects dedicated to the business environment. We operate as a holding structure, offering operational support, strategy, consulting, and infrastructure for the projects and brands developed under the IndustryTOP umbrella.',
      descriptionExtended: 'Founded in the heart of Dubai\'s global financial center, IndustryTOP represents the shared vision of two entrepreneurs passionate about innovation, development, and positive impact. Our company was designed to address the complex needs of the contemporary business environment, offering not just consulting, but a complete ecosystem of support for projects with exponential growth potential. From conceptualization to implementation and scaling, IndustryTOP is the strategic partner that transforms ideas into sustainable and profitable businesses.',
      approachTitle: 'Our Approach',
      approachText: 'We believe in the power of collaboration and the value of specialized expertise. Each project in our portfolio benefits from access to strategic resources, operational know-how, and an extensive network of international partners. We don\'t limit ourselves to offering advice – we build, alongside our clients and partners, the foundation for long-term success. Our methodology combines rigorous analysis, strategic creativity, and impeccable execution.',
      valuesTitle: 'Our Values',
      valuesIntro: 'Our core values guide every decision and action:',
      values: ['Integrity', 'Transparency', 'Professionalism', 'Efficiency', 'Innovation', 'Results-Orientation'],
      valuesExtended: [
        {
          value: 'Integrity',
          description: 'We act with honesty and ethics in all our interactions, building relationships based on trust and mutual respect.'
        },
        {
          value: 'Transparency',
          description: 'We communicate openly and clearly, ensuring that all partners and clients understand the processes, progress, and challenges of projects.'
        },
        {
          value: 'Professionalism',
          description: 'We maintain the highest standards of quality in everything we do, respecting deadlines and exceeding expectations.'
        },
        {
          value: 'Efficiency',
          description: 'We optimize resources, time, and processes to deliver maximum results with minimum investment.'
        },
        {
          value: 'Innovation',
          description: 'We constantly seek new ways to improve, adapt, and innovate, staying relevant in an ever-changing world.'
        },
        {
          value: 'Results-Orientation',
          description: 'Success is measured in concrete results, and every strategy is built with clear objectives and measurable indicators.'
        }
      ],
      visionTitle: 'Vision',
      vision: 'To become a global hub of modern projects and brands beneficial to communities and businesses.',
      visionExtended: 'We aspire to create an international ecosystem recognized for excellence, innovation, and positive impact. Our vision is to be the preferred partner for entrepreneurs and companies who want to build sustainable brands, access global markets, and generate real value for the communities they serve.',
      missionTitle: 'Mission',
      mission: 'Creating and growing brands oriented towards people, technology, and progress.',
      missionExtended: 'Our mission is to identify opportunities, build solutions, and support the development of projects and brands that improve people\'s lives, use technology responsibly, and contribute to global progress. We focus on sustainability, scalability, and long-term relevance.',
      foundersTitle: 'Founders',
      foundersIntro: 'IndustryTOP is the result of the shared vision of two experienced entrepreneurs, each bringing a unique and complementary perspective:',
      sharedVision: 'Under the IndustryTOP umbrella, the two founders aim to develop a global ecosystem of modern projects and impactful brands. Together, Marius and Milentina combine technical and strategic expertise with community development and leadership skills, creating an environment conducive to innovation and sustained growth.'
    },
    brands: {
      title: 'Our Brands',
      subtitle: 'Ecosystem of modern projects with global impact',
      viewProject: 'View Project'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch for collaborations and partnerships',
      introText: 'We are here to listen and help you transform ideas into reality. Whether you want to learn more about our services, discuss a specific project, or explore collaboration opportunities, the Industry Top team is ready to respond.',
      availabilityText: 'We actively respond to all requests within 24-48 business hours. For urgent inquiries or direct discussions, please contact us via email and we will schedule a meeting as soon as possible.',
      form: {
        name: 'Name',
        email: 'Email',
        message: 'Message',
        send: 'Send Message'
      },
      info: {
        company: 'IndustryTOP Consulting LLC-FZ',
        location: 'Dubai, United Arab Emirates',
        email: 'contact@industry-top.com'
      },
      success: 'Message sent successfully!',
      error: 'An error occurred. Please try again.'
    },
    footer: {
      copyright: '© 2025 IndustryTOP Consulting LLC-FZ, Dubai, UAE. All rights reserved.',
      built: 'Built by digital.marexon.com',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service'
    },
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated: December 6, 2025',
      sections: [
        {
          title: '1. Introduction',
          content: 'IndustryTOP Consulting LLC-FZ ("we", "our company") is registered in Dubai, United Arab Emirates. This Privacy Policy describes how we collect, use, and protect your personal information in accordance with applicable UAE laws, including UAE Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data.'
        },
        {
          title: '2. Information Collected',
          content: 'We collect the following types of information: contact details (name, email, phone), company information, website usage data, and cookies to improve user experience.'
        },
        {
          title: '3. Use of Information',
          content: 'We use collected information to: provide our services, communicate with clients, improve services, comply with legal obligations, and marketing (only with your consent).'
        },
        {
          title: '4. Data Protection',
          content: 'We implement technical and organizational security measures to protect personal data against unauthorized access, loss, or alteration. Data is stored on secure and encrypted servers.'
        },
        {
          title: '5. Information Sharing',
          content: 'We do not sell or rent personal data to third parties. Information may only be shared with: trusted service providers, competent authorities (upon legal request), and business partners (only with your consent).'
        },
        {
          title: '6. Your Rights',
          content: 'Under UAE law, you have the right to: access personal data, rectification and deletion, restriction of processing, data portability, and withdrawal of consent. To exercise these rights, contact us at contact@industry-top.com.'
        },
        {
          title: '7. Cookies',
          content: 'We use cookies to improve website functionality. You can manage cookie preferences through your browser settings.'
        },
        {
          title: '8. Contact',
          content: 'For questions about this policy, contact us: IndustryTOP Consulting LLC-FZ, Dubai, UAE, Email: contact@industry-top.com'
        }
      ]
    },
    terms: {
      title: 'Terms and Conditions',
      lastUpdated: 'Last Updated: December 6, 2025',
      sections: [
        {
          title: '1. Acceptance of Terms',
          content: 'By accessing and using this website, you agree to be bound by these Terms and Conditions in accordance with UAE laws, including UAE Commercial Companies Law (Federal Law No. 2 of 2015).'
        },
        {
          title: '2. About the Company',
          content: 'IndustryTOP Consulting LLC-FZ is a consulting company registered in Dubai, UAE, specializing in the development of modern projects, brands, and solutions for the international business environment.'
        },
        {
          title: '3. Website Use',
          content: 'We grant you a limited, non-exclusive, non-transferable license to use this website for lawful purposes. Prohibited activities include: illegal use, unauthorized access attempts, malware distribution, or copying content without authorization.'
        },
        {
          title: '4. Intellectual Property',
          content: 'All content on this website, including text, graphics, logos, images, and software, is the property of IndustryTOP Consulting LLC-FZ and is protected by UAE copyright and intellectual property laws.'
        },
        {
          title: '5. Services and Pricing',
          content: 'Information about services and pricing presented on this website is indicative. Final offers will be communicated based on each client\'s specific requirements. We reserve the right to modify services and prices without prior notice.'
        },
        {
          title: '6. Limitation of Liability',
          content: 'To the extent permitted by UAE law, IndustryTOP Consulting LLC-FZ shall not be liable for direct, indirect, incidental, or consequential damages resulting from the use or inability to use the website.'
        },
        {
          title: '7. Third-Party Links',
          content: 'The website may contain links to external sites. We are not responsible for the content or privacy practices of these sites.'
        },
        {
          title: '8. Changes to Terms',
          content: 'We reserve the right to modify these terms at any time. Changes will take effect immediately upon posting on the website. Continued use of the website after changes constitutes acceptance of the new terms.'
        },
        {
          title: '9. Governing Law',
          content: 'These terms are governed by the laws of the United Arab Emirates. Any disputes will be resolved in the jurisdiction of Dubai courts, UAE.'
        },
        {
          title: '10. Contact',
          content: 'For questions about these terms, contact us: IndustryTOP Consulting LLC-FZ, Dubai, UAE, Email: contact@industry-top.com'
        }
      ]
    }
  }
};

export const founders = [
  {
    name: 'MARIUS MARCUS',
    initials: 'MM',
    photo: 'https://customer-assets.emergentagent.com/job_dubai-business/artifacts/jahlsuwn_Marius-76%281%29%281%29%281%29.jpg',
    description: {
      ro: 'Co-fondator IndustryTOP Consulting LLC-FZ și inițiator al proiectului AI Biz Accelerator. Expert în consultanță, strategie digitală și dezvoltare de proiecte scalabile.',
      en: 'Co-founder of IndustryTOP Consulting LLC-FZ and initiator of the AI Biz Accelerator project. Expert in consulting, digital strategy, and scalable project development.'
    }
  },
  {
    name: 'MILENTINA MARCUS',
    initials: 'MM',
    photo: 'https://customer-assets.emergentagent.com/job_dubai-business/artifacts/gp211738_milentina%202.jpg',
    description: {
      ro: 'Co-fondatoare IndustryTOP și fondatoarea Romanian Business Connect UAE și MilentinaMarcus.com. Specialist în coaching, dezvoltare personală și construire de comunități.',
      en: 'Co-founder of IndustryTOP and founder of Romanian Business Connect UAE and MilentinaMarcus.com. Specialist in coaching, personal development, and community building.'
    }
  }
];

export const brands = [
  {
    id: 1,
    name: 'Romanian Business Connect',
    description: {
      ro: 'Platformă internațională de networking și colaborare pentru români.',
      en: 'International networking and collaboration platform for Romanians.'
    },
    detailedDescription: {
      ro: 'Romanian Business Connect este o platformă globală dedicată comunității românești de afaceri din întreaga lume. Proiectul conectează antreprenori, profesioniști și companii românești, oferind oportunități de networking, colaborare și dezvoltare. Prin evenimente, resurse educaționale și o comunitate activă, Romanian Business Connect susține creșterea și internacionalizarea afacerilor românești, promovând valorile culturale și profesionalismul specific României pe piețele globale.',
      en: 'Romanian Business Connect is a global platform dedicated to the Romanian business community worldwide. The project connects Romanian entrepreneurs, professionals, and companies, offering networking, collaboration, and development opportunities. Through events, educational resources, and an active community, Romanian Business Connect supports the growth and internationalization of Romanian businesses, promoting cultural values and Romanian professionalism in global markets.'
    },
    logo: 'https://customer-assets.emergentagent.com/job_dubai-business/artifacts/booa4w2p_logo%20rbc.png',
    link: 'https://romanianbusinessconnect.com'
  },
  {
    id: 2,
    name: 'MilentinaMarcus.com',
    description: {
      ro: 'Proiect dedicat coachingului, dezvoltării personale și educației.',
      en: 'Project dedicated to coaching, personal development, and education.'
    },
    detailedDescription: {
      ro: 'MilentinaMarcus.com este un proiect dedicat împuternicirii feminine prin coaching, dezvoltare personală și educație. Fondat de Milentina Marcus, proiectul oferă programe personalizate de coaching, resurse educaționale și comunități de suport pentru femei care doresc să își dezvolte potențialul maxim – atât în carieră, cât și în viața personală. Cu o abordare holistică, MilentinaMarcus.com combină tehnici moderne de coaching cu înțelepciunea practică, ajutând femeile să își atingă obiectivele și să trăiască o viață împlinită și autentică.',
      en: 'MilentinaMarcus.com is a project dedicated to female empowerment through coaching, personal development, and education. Founded by Milentina Marcus, the project offers personalized coaching programs, educational resources, and support communities for women who want to develop their full potential – both in career and personal life. With a holistic approach, MilentinaMarcus.com combines modern coaching techniques with practical wisdom, helping women achieve their goals and live a fulfilled and authentic life.'
    },
    logo: 'https://customer-assets.emergentagent.com/job_dubai-business/artifacts/3af68sot_Milentina%20Mrcus.jpg',
    link: 'https://milentinamarcus.com'
  },
  {
    id: 3,
    name: 'AI Biz Accelerator',
    description: {
      ro: 'Proiect IndustryTOP pentru soluții, resurse și instrumente AI dedicate afacerilor.',
      en: 'IndustryTOP project for AI solutions, resources, and tools dedicated to businesses.'
    },
    detailedDescription: {
      ro: 'AI Biz Accelerator este platforma IndustryTOP dedicată integrării inteligenței artificiale în mediul de afaceri. Proiectul oferă soluții practice, resurse educaționale și instrumente AI accesibile pentru companii care doresc să automatizeze procese, să optimizeze operațiuni și să ia decizii bazate pe date. De la chatbots inteligenti până la analize predictive, AI Biz Accelerator face tehnologia AI accesibilă și aplicabilă pentru afaceri de orice dimensiune, ajutându-le să rămână competitive într-o lume tot mai digitalizată.',
      en: 'AI Biz Accelerator is the IndustryTOP platform dedicated to integrating artificial intelligence into the business environment. The project offers practical solutions, educational resources, and accessible AI tools for companies looking to automate processes, optimize operations, and make data-driven decisions. From intelligent chatbots to predictive analytics, AI Biz Accelerator makes AI technology accessible and applicable to businesses of any size, helping them stay competitive in an increasingly digitized world.'
    },
    logo: 'https://customer-assets.emergentagent.com/job_dubai-business/artifacts/vy7e3idn_Black%20logo%20-%20no%20background.png',
    link: 'https://aibizaccelerator.industry-top.com/'
  }
];

export const images = {
  heroBackground: 'https://images.pexels.com/photos/2115367/pexels-photo-2115367.jpeg'
};